import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Posto } from '@core/models/models';

@Component({
  selector: 'app-posto-info-tab',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './posto-info-tab.component.html',
  styleUrl: './posto-info-tab.component.scss'
})
export class PostoInfoTabComponent {
  @Input() posto!: Posto;


}
